import React from 'react';
import { Search, Loader2 } from 'lucide-react';

/**
 * Shared page hero with a search pill. Used by home (full) and the
 * jobs / employers / candidates listings (compact).
 *
 * fields: [{ key, placeholder, icon: LucideIcon, value, onChange }]
 */
function SearchHero({
    compact = false,
    eyebrow,
    title,
    lead,
    fields,
    onSubmit,
    loading = false,
    submitLabel,
    children
}) {
    return (
        <section className={`jf-public jf-hero${compact ? ' jf-hero--compact' : ''}`}>
            <div className="jf-container" style={{ textAlign: compact ? 'start' : 'center' }}>
                {eyebrow && !compact && <span className="jf-eyebrow"><i />{eyebrow}</span>}
                {title && <h1>{title}</h1>}
                {lead && <p className="jf-hero__lead" style={{ marginBottom: compact ? 22 : 36 }}>{lead}</p>}

                <form className="jf-search" onSubmit={onSubmit} role="search">
                    {fields.map(({ key, placeholder, icon: Icon, value, onChange }) => (
                        <label className="jf-search__field" key={key}>
                            <Icon size={19} aria-hidden="true" />
                            <input
                                type="text"
                                value={value}
                                placeholder={placeholder}
                                aria-label={placeholder}
                                onChange={(e) => onChange(e.target.value)}
                            />
                        </label>
                    ))}
                    <button type="submit" className="jf-search__btn" disabled={loading}>
                        {loading ? <Loader2 size={18} className="jf-spin" /> : <Search size={18} />}
                        {submitLabel}
                    </button>
                </form>

                {children}
            </div>
        </section>
    );
}

export default SearchHero;
